import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router";
import useView from "../../hooks/useView";
import {
    callCategoriesDetail,
    cleanCategoriesDetail,
    handleResetQuote
} from "../../redux/actions";
import { RootState } from "../../redux/reducers";
import config, { path } from "../../config/enviroment";
import { Body, Container } from "../../theme/theme";
import CardCategoryDetail from "../../components/CardCategoryDetail";
import FooterPagination from "../../components/FooterPagination";
import HeadPagination from "../../components/HeadPagination";
import { NotFoundText, NotFoundContainer, SearchTitleResult, } from "./style";
import useQuery from "../../hooks/useQuery";
import { language } from "../../utils/language";
import FreeShippingMinBanner from "../../components/FreeShippingMinBanner";

const SearchProducts: FunctionComponent = () => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const categoryDetailState: any = useSelector(
        (state: RootState) => state.categoryDetail
    );
    const { width } = useView();
    const dispatch = useDispatch();
    const query = useQuery();
    const history = useHistory();
    const routeLocation = useLocation().search;
    const [order, setOrder] = useState("outstanding");
    const [typeList, setTypeList] = useState("colum");
    const [page, setPage] = useState(() => {
        return query.get("page") ?? 1;
    });

    const basePath = `/search`;
    const isMobile = width <= 1000;
    const queryToSearch = query.get("q") ?? "";
    const idCategory = query.get("category") ?? "All";

    useEffect(() => {
        if(queryToSearch !== ''){
            fetch()
        }
    }, [routeLocation, order]);

    useEffect(() => {
        dispatch(handleResetQuote())
    }, [])

    const fetch = () => {
        const filter = buildFilterRequest()
        dispatch(cleanCategoriesDetail())
        dispatch(callCategoriesDetail(path, filter))
    }

    const buildFilterRequest = () => {
        const filter: any = {
            url: path,
            filter: {
                origin: "epayco",
                title: queryToSearch,
                order: order
            },
            pagination: {
                page: page,
                limit: isMobile ? 8 : 12,
            },
        };

        if (idCategory !== "All" && idCategory !== "Destacado") filter.filter.categorieId = parseInt(idCategory);

        if (idCategory === "Destacado") filter.filter.outstanding = true;

        return filter;
    }


    const handleOrder = (event: any) => {
        setOrder(event.target.value)
    };

    const handleTypeList = (type: string) => {
        setTypeList(type)
    };

    const handleList = (pageSelected: number) => {
        dispatch(cleanCategoriesDetail())
        setPage(pageSelected)
        history.push(`${basePath}q=${query}&category=${idCategory}&page=${page}`)
    };

    const getProductsLength = () => {
        if (categoryDetailState.loading) {
            return queryToSearch === '' ?  0 : language[homeState.default_language]["loading"]
        }
        if (Array.isArray(categoryDetailState.listCategoryDetailPaginate))
            return categoryDetailState.listCategoryDetailPaginate.length
        return categoryDetailState.listCategoryDetailPaginate.data.length
    };

    const getTitle = (renderOn: string) => {
        return (((isMobile)  && (renderOn === 'mobile')) || ((!isMobile)  && (renderOn === 'desktop'))) ?  (
            <SearchTitleResult color={homeState.color}>
                {`${getProductsLength()} ${language[homeState.default_language]["resultFor"]} "${query.get('q')}"`}
            </SearchTitleResult> ) : null
    }

    return (
        <Body>
            <FreeShippingMinBanner inContent />
            {getProductsLength() === 0 ? (
                <NotFoundContainer>
                    <svg data-src={`${config.urlMultimedia}/vende/landing-img/notFoundLens.svg`}/>
                    <NotFoundText>{language[homeState.default_language]["notFoundProduct"]}</NotFoundText>
                </NotFoundContainer>
            ) : (
                <>
                    <Container>
                        {getTitle('desktop')}
                        <HeadPagination
                            homeState={homeState}
                            list={categoryDetailState.listCategoryDetailPaginate}
                            handleOrder={handleOrder}
                            typeList={typeList}
                            handleTypeList={handleTypeList}
                            isMobile={isMobile}
                            showPaginationInformationOnMobile={true}
                            idCategory={parseInt(idCategory)}
                        />
                        {getTitle('mobile')}
                        <CardCategoryDetail
                            showAsGrid
                            skeletonCardsRows={3}
                            homeState={homeState}
                            productList={categoryDetailState.listCategoryDetail}
                            typeList={typeList}
                            loading={categoryDetailState.loading}
                            isMobile={isMobile}
                        />
                    </Container>
                    <FooterPagination
                        homeState={homeState}
                        list={categoryDetailState.listCategoryDetailPaginate}
                        handleList={handleList}
                        loading={categoryDetailState.loading}
                        isMobile={isMobile}
                    />
                </>
            )}
        </Body>
    );
};

export default SearchProducts;
